import React from 'react';
import Module from './Module';

export default props => {
  const { inViewport, forwardedRef } = props;
  return (
    <Module type="text" style={{
       backgroundColor: props.background,
       color: props.foreground
    }}>
      <div className="inner">
        {props.text &&
          <div className="text" dangerouslySetInnerHTML={{__html: props.text}} />
        }
      </div>
    </Module>
  )
};
